function BricksIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M29.5 15H20.5L20.5 27H29.5V15ZM20.5 13C19.3954 13 18.5 13.8954 18.5 15V27C18.5 28.1046 19.3954 29 20.5 29H29.5C30.6046 29 31.5 28.1046 31.5 27V15C31.5 13.8954 30.6046 13 29.5 13H20.5Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.5 7H4.5L4.5 19H13.5V7ZM4.5 5C3.39543 5 2.5 5.89543 2.5 7V19C2.5 20.1046 3.39543 21 4.5 21H13.5C14.6046 21 15.5 20.1046 15.5 19V7C15.5 5.89543 14.6046 5 13.5 5H4.5Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default BricksIcon;
